import { render, staticRenderFns } from "./workerPage.vue?vue&type=template&id=fb0b29e6&"
import script from "./workerPage.vue?vue&type=script&lang=js&"
export * from "./workerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports